var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showInstaller, "can-cancel": false, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showInstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _c("i", { staticClass: "fas fa-cube" }),
            _vm._v(" Instalación: Notificaciones"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Configuración de parametros"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Carpeta de Notificaciones"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button is-static is-fullwidth has-text-left",
                    },
                    [_vm._v(_vm._s(_vm.getRuta))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("explorer", {
                ref: "listado",
                attrs: {
                  idFolder: _vm.settings.origen_id || _vm.organizacion.slug,
                  rutas: _vm.rutas,
                  selected: _vm.selected,
                },
                on: {
                  "update:rutas": function ($event) {
                    _vm.rutas = $event
                  },
                  "update:selected": function ($event) {
                    _vm.selected = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v("Elija la carpeta donde se guardarán los documentos."),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Flujo de firmas del usuario"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.settings.firmaUsuario,
                        expression: "settings.firmaUsuario",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.settings,
                          "firmaUsuario",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Sin firma"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v("Firma débil"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v("Firma fuerte"),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Almacenes de software"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "backup" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "backup") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "backup",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            Almacén en SignAR\n          "),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "hwtoken" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "hwtoken") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "hwtoken",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            Token de hardware\n          "),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("(Opcional) Área de Administradores de RRHH"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.areaAdminRRHH,
                    expression: "settings.areaAdminRRHH",
                  },
                ],
                staticClass: "input",
                attrs: { name: "area", type: "number" },
                domProps: { value: _vm.settings.areaAdminRRHH },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.settings, "areaAdminRRHH", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "notification is-primary" }, [
              _c("i", { staticClass: "fas fa-info-circle fa-fw" }),
              _vm._v(" Recuerde asignar los roles "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Administrador de notificaciones"),
              ]),
              _vm._v(" y "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Usuario de notificaciones"),
              ]),
              _vm._v(
                "  a los usuarios para que utilicen la funcionalidad.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "notification is-warning" }, [
              _c("i", { staticClass: "fas fa-exclamation-triangle fa-fw" }),
              _vm._v(
                " Las coordenadas de firma no pueden cargarse debido a que se optó a que los usuarios utilicen "
              ),
              _c(
                "span",
                { staticClass: "is-underlined has-text-weight-bold" },
                [_vm._v("firma invisible")]
              ),
              _vm._v(
                " (para evitar solapamientos de firma y por los diferentes tamaños entre distintos documentos) y los administradores siempre "
              ),
              _c(
                "span",
                { staticClass: "is-underlined has-text-weight-bold" },
                [_vm._v("firmen abajo a la derecha")]
              ),
              _vm._v(".\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("div", { staticClass: "buttons is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-dark is-outlined",
                  on: { click: _vm.cancelar },
                },
                [_vm._v("\n            Cancelar\n          ")]
              ),
              _vm._v(" "),
              _vm.params
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: {
                        disabled:
                          _vm.errors.count() > 0 || _vm.disableConfirmButton,
                      },
                      on: { click: _vm.reinstalar },
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: {
                        disabled:
                          _vm.errors.count() > 0 || _vm.disableConfirmButton,
                      },
                      on: { click: _vm.instalar },
                    },
                    [_vm._v("\n            Instalar módulo\n          ")]
                  ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }